import { Injectable, PLATFORM_ID, inject, EventEmitter } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  public heroToggleEvent:EventEmitter<boolean> = new EventEmitter<boolean>();
  public desktopSidebarToggleEvent:EventEmitter<boolean> = new EventEmitter<boolean>();
  private _desktopSidebarOpen = true;
  private platformId = inject(PLATFORM_ID);

  constructor() {
    if (this.isBrowser()) {
      localStorage.removeItem('desktopSidebarOpen');
    }
  }

  getIsDesktopSidebarOpen(): boolean {
    if (this.isBrowser()) {
      const stored = localStorage.getItem('desktopSidebarOpen');
      if (stored !== null) {
        return stored === 'true';
      }
    }
    return this._desktopSidebarOpen;
  }

  setDesktopSidebarOpen(value: boolean): void {
    this._desktopSidebarOpen = value;
    if (this.isBrowser()) {
      localStorage.setItem('desktopSidebarOpen', value ? 'true' : 'false');
    }
    this.desktopSidebarToggleEvent.emit(value);
  }

  /**
   * Checks if the platform is a browser.
   * @returns True if the platform is a browser, false otherwise.
   */
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  /**
   * Checks if the platform is a server.
   * @returns True if the platform is a server, false otherwise.
   */
  isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  /**
   * Determines if the user is on a mobile device.
   * @returns True if the user is on a mobile device, false otherwise.
   */
  isMobileDevice(): boolean {
    if (this.isBrowser()) {
      const userAgent = navigator.userAgent || navigator.vendor;
      if(userAgent && /Mobile|Android|iP(ad|hone|od)|IEMobile|WPDesktop|Kindle/.test(userAgent))
        return true;
    }
    return false;
  }

  /**
   * Determines if the user is on an Apple device.
   * @returns True if the user is on an Apple device, false otherwise.
   */
  isAppleDevice(): boolean {
    if (this.isBrowser()) {
      const userAgent = navigator.userAgent || navigator.vendor;
      if(userAgent && /AppleWebKit/.test(userAgent) && /iPad|iPhone|iPod/.test(userAgent))
        return true;
    }
    return false;
  }
}
